import type { AlertProps } from '@mui/material';

import { BannerAudience, BannerType } from '@libraries/api/gen-api-admin';

export function severityToBannerType(severity: AlertProps['severity']): BannerType {
  switch (severity) {
    case 'info':
      return BannerType.Info;
    case 'warning':
      return BannerType.Warning;
    case 'error':
      return BannerType.Urgent;
    case 'success':
      return BannerType.Success;
    default:
      throw new Error('Unmatched severity');
  }
}

export function bannerTypeToSeverity(bannerType: BannerType): AlertProps['severity'] {
  switch (bannerType) {
    case BannerType.Info:
      return 'info';
    case BannerType.Warning:
      return 'warning';
    case BannerType.Urgent:
      return 'error';
    case BannerType.Success:
      return 'success';
    default:
      throw new Error('Unmatched BannerType');
  }
}

// TODO - Use translation or constant for these labels?
export function audienceTypeToLabel(audience: BannerAudience): string {
  switch (audience) {
    case BannerAudience.Console:
      return 'Enterprise console';
    case BannerAudience.Serviceconsole:
      return 'Service console';
    default:
      throw new Error('Unmatched BannerAudience');
  }
}
